export const authenticationDropdownOptions = [
  {
    id: 1,
    name: 'POST'
  },
  {
    id: 2,
    name: 'PUT'
  },
  {
    id: 3,
    name: 'PATCH'
  }
];

export const authenticationHeader = [
  {
    id: 1,
    name: 'Default Header',
    value: 'defaultHeader',
    label: 'DEFAULT_HEADER'
  },
  {
    id: 2,
    name: 'Basic Authentication',
    value: 'basicAuthentication',
    label: 'BASIC_AUTH'
  },
  {
    id: 3,
    name: 'Token Authentication',
    value: 'tokenAuthentication',
    label: 'TOKEN_AUTH'
  },
  {
    id: 4,
    name: 'Oauth Authentication',
    value: 'oauthAuthentication',
    label: 'OAUTH_CLIENT_CRED'
  },
  {
    id: 5,
    name: 'Custom Header',
    value: 'customHeader',
    label: 'CUSTOM_HEADER'
  }
];

export const headerCircles = [
  {
    id: 1,
    color: '#FF605C'
  },
  {
    id: 2,
    color: '#FFBD44'
  },
  {
    id: 3,
    color: '#00CA4E'
  }
];

export const defaultValues = {
  appName: '',
  shortDescription: '',
  supportEmail: '',
  supportUrl: '',
  websiteLink: '',
  icon: {},
  secretKey: '',
  url: '',
  isValidated: '',
  events: [],
  authentication: 'DEFAULT_HEADER',
  properties: {
    httpMethod: 'POST',
    headers: {
      username: '',
      password: '',
      clientId: '',
      clientSecret: '',
      tokenURL: '',
      customKey: '',
      customValue: '',
      scopes: ''
    }
  },
  appId: 0
};

export const customFieldDefaultValue = {
  headerKey: '',
  headerValue: '',
  id: 1
};

export const urlRegex =
  /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/;

export const webhookHeaders = {
  CUSTOM_HEADER: 'customHeader',
  DEFAULT_HEADER: 'defaultHeader'
}

export const warningModalStates = {
  DELETE: 'delete',
  DISABLE: 'disable'
}

export const filterStates = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
}